export default __webpack_public_path__ + "static/media/gordita-medium.48050d17.woff";